export var DEPLOY_DATE = new Date('2026-10-08T20:00:59+0000');
